import api from "./api";
const qs = (p={}) => new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)).toString();
const svc = {
  buscarConfig:       (idCondominio, tpConsumo) => api("GET",`/consumo/config?idCondominio=${idCondominio}&tpConsumo=${tpConsumo}`),
  salvarConfig:       (data)                    => api("POST","/consumo/config",data),
  listarMedidores:    (p={})                    => api("GET",`/consumo/medidores?${qs(p)}`),
  criarMedidor:       (data)                    => api("POST","/consumo/medidores",data),
  atualizarMedidor:   (id,data)                 => api("PUT",`/consumo/medidores/${id}`,data),
  listarLeituras:     (p={})                    => api("GET",`/consumo/leituras?${qs(p)}`),
  previewLeituras:    (data)                    => api("POST","/consumo/leituras/preview",data),
  confirmarLeituras:  (data)                    => api("POST","/consumo/leituras/confirmar",data),
  cancelarLeitura:    (id)                      => api("PATCH",`/consumo/leituras/${id}/cancelar`,{}),
  listarCiclos:       (p={})                    => api("GET",`/consumo/ciclos?${qs(p)}`),
  relatorio:          (p={})                    => api("GET",`/consumo/relatorio?${qs(p)}`),

  // ── Foto + OCR ──
  ocrPreview:         (data)                    => api("POST","/consumo/leituras/ocr",data),
  uploadFoto:         (data)                    => api("POST","/consumo/leituras/fotos",data),
  listarFotos:        (p={})                    => api("GET",`/consumo/leituras/fotos?${qs(p)}`),
  deletarFoto:        (id)                      => api("DELETE",`/consumo/leituras/fotos/${id}`),
};
export default svc;
